import * as React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { A11y, Navigation } from "swiper";
import "swiper/css";
import Link from "./link";
import { FormattedMessage } from "react-intl";
import Arrow from "./arrow";
import Badges from "./badges";

SwiperCore.use([A11y, Navigation]);

const SlideshowProducts = ({ products, title, variant }) => {
  const prevEl = React.useRef(null);
  const nextEl = React.useRef(null);

  if (!products || products.length === 0) {
    return null;
  }

  const sortedProducts = products.sort((a, b) => {
    const aHasOrder = typeof a.order === "number";
    const bHasOrder = typeof b.order === "number";

    if (aHasOrder && bHasOrder) {
      return a.order - b.order;
    }

    if (aHasOrder && !bHasOrder) return -1;
    if (!aHasOrder && bHasOrder) return 1;

    return 0;
  });

  return (
    <section className="slideshow-products destinations" data-variant={variant}>
      <div className="container">
        <header>
          <h2 id="slideshow-products-heading" className="heading heading-large">
            {title}
          </h2>
        </header>
        <div className="destinations-slideshow">
          <button ref={prevEl} className="swiper-button-prev">
            <Arrow id="prev" />
          </button>
          <button ref={nextEl} className="swiper-button-next">
            <Arrow id="next" />
          </button>
          <Swiper
            slidesPerView="auto"
            centerInsufficientSlides={true}
            breakpoints={{
              1024: {
                slidesPerView: 3.2,
                spaceBetween: 24,
              },
            }}
            onBeforeInit={(swiper) => {
              swiper.params.navigation.prevEl = prevEl.current;
              swiper.params.navigation.nextEl = nextEl.current;
            }}
          >
            {sortedProducts.map((product, index) => (
              <React.Fragment key={`${product.fieldValue}-${index}`}>
                <SwiperSlide key={`${product.contentful_id}-${index}`}>
                  <Link
                    href={`/destinations/${product.destination.slug}${
                      product.destination.products.length > 1
                        ? `/${product?.referenceProduit?.toLowerCase()}${
                            product?.stayReference
                              ? `/${product?.stayReference.toLowerCase()}`
                              : ""
                          }`
                        : ""
                    }`}
                  >
                    <span className="visually-hidden">
                      {product.destination.title}
                    </span>
                  </Link>
                  <div>
                    <Badges badges={product.badges} />
                    <div className="swiper-slide-title">
                      <h3 aria-hidden>{product.destination.title}</h3>
                      <p className="slideshow-products-duration">
                        {product.subtitleCarousel || product.duration}
                      </p>
                      <span className="link destinations-slideshow-booking-label">
                        <FormattedMessage id="see" />
                      </span>
                    </div>
                    {product.featuredImage && (
                      <GatsbyImage
                        image={product.featuredImage.gatsbyImageData}
                        alt={product.featuredImage.title}
                      />
                    )}
                  </div>
                </SwiperSlide>
              </React.Fragment>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default SlideshowProducts;
